// Custom CSS for Shopify Inbox chat (shadow DOM)
document.addEventListener('DOMContentLoaded', () => {
  const rootStyles = getComputedStyle(document.documentElement);
  const primary = rootStyles.getPropertyValue('--btn-color').trim() || '#1F2A40';
  const primaryHover = rootStyles.getPropertyValue('--btn-hover-color').trim() || '#162032';
  const textColor = rootStyles.getPropertyValue('--btn-text-color').trim() || '#FFFFFF';

  const CSS_RULE = `
    button.chat-toggle { height: 40px; width: 40px; background: ${primary} !important; border-color: ${primary} !important; color: ${textColor} !important; }
    button.chat-toggle.chat-toggle--icon-button.icon-only svg,
    button.chat-toggle.chat-toggle--icon-button.mobile-only svg { height: 35px; }
    button.chat-toggle.chat-toggle--text-button { height: 50px; }
    .chat-app .chat-app--close-button { height: 45px; width: 45px; background: ${primary} !important; border-color: ${primary} !important; color: ${textColor} !important; }
    button.chat-toggle svg { height: 40px; }
    button.chat-toggle .chat-title { font-size: 20px; }
    button.chat-toggle:hover,
    .chat-app .chat-app--close-button:hover { background: ${primaryHover} !important; border-color: ${primaryHover} !important; }
    button.chat-toggle svg path,
    .chat-app .chat-app--close-button svg path { fill: ${textColor} !important; }
  `.trim();

  const STYLE_ID = 'custom-shopify-chat-css';

  function getShadowHost() {
    return document.querySelector('inbox-online-store-chat') || document.querySelector('#ShopifyChat');
  }

  function injectStyle(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS_RULE;
    shadowRoot.appendChild(style);
  }

  function tryApply() {
    const host = getShadowHost();
    if (host?.shadowRoot) {
      injectStyle(host.shadowRoot);
      return true;
    }
    return false;
  }

  let observer;
  let timer;
  let hasCleanedUp = false;

  const cleanup = () => {
    if (hasCleanedUp) return;
    hasCleanedUp = true;
    if (observer) observer.disconnect();
    if (timer) clearInterval(timer);
  };

  // initial
  if (tryApply()) return;

  // keep watching in case widget mounts later or re-renders
  observer = new MutationObserver(() => {
    if (tryApply()) cleanup();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // fallback: sometimes shadowRoot attaches late
  const start = Date.now();
  timer = setInterval(() => {
    if (tryApply() || Date.now() - start > 10000) {
      cleanup();
    }
  }, 200);
});
